module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAYAAACtWacbAAAAAXNSR0IArs4c6QAAAJFJREFUKFO9kDEOQVEQRc9R2oT8DahUOtGqJTo6vZ6wAK1Wo1NYgF5rBfJ3oZIR8p48P2pTzc2cmbm5kioidsA8a2Cvzl7aP0MRMQU6wAjoFZ6uwAmojYghcC6GzXbwNh4Ra2D5A1ypmwy1gQvQbbzrq/cyggq4FVCl1l85pbcT4ACM1WNe+FxKUAvYAgv1kaEn1OY4pbKncZ8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-up.png
// module id = E9PP
// module chunks = 1